/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KeyValuePair } from './keyValuePair';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsDisconnectedDeploymentCommerceHistory } from './vcdsDisconnectedDeploymentCommerceHistory';
import { VcdsDisconnectedDeploymentStateEnum } from './vcdsDisconnectedDeploymentStateEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface VcdsDisconnectedDeploymentRaw { 
    /**
     * Org Id
     */
    org_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * Component name
     */
    name?: string;
    /**
     * Resource FQDN
     */
    fqdn?: string;
    /**
     * Deployment Id
     */
    deployment_id?: string;
    /**
     * Peer Deployment Id
     */
    peer_deployment_id?: string;
    /**
     * Provider ID in format: <res-type>-<res-id>
     */
    vcenter_id?: string;
    sequence_number?: number;
    state?: VcdsDisconnectedDeploymentStateEnum;
    commerce_mode?: CommerceModeEnum;
    personas?: Array<string>;
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Component Version
     */
    component_version?: string;
    /**
     * Created by user
     */
    created_by?: string;
    /**
     * Deployment creation date time
     */
    created_ts?: Date;
    /**
     * encrypted hash value of deactivation code
     */
    deactivation_code?: string;
    /**
     * Deleted by user
     */
    deleted_by?: string;
    /**
     * Deployment deletion date time
     */
    deleted_ts?: Date;
    /**
     * Expiry date
     */
    expiry_date?: Date;
    history?: Array<VcdsDisconnectedDeploymentCommerceHistory>;
    metadata?: Array<KeyValuePair>;
    quantity?: number;
    /**
     * Updated by user
     */
    update_by?: string;
    /**
     * Deployment last updated date time
     */
    updated_ts?: Date;
}
export namespace VcdsDisconnectedDeploymentRaw {
}


